import React from 'react';
import { StatusBar } from 'react-native';

import PropTypes from 'prop-types';

import { VFScreen } from '@vfgroup-oneplatform/foundation/Components';

import FrameworkTestKeys from '../../FrameworkTestKeys';
import AddPayment from '../Containers/AddPayment';

const AddPaymentScreen = ({ onClose, onBack, ...props }) => {
  return (
    <VFScreen
      onClose={onClose}
      onBack={onBack}
      withStatusBar={false}
      showBack
      title={'payment_add_new_card_screen_title'}
      closeButtonTestID={FrameworkTestKeys.AddPaymentCloseButton}
    >
      <StatusBar translucent={false} backgroundColor={'transparent'} />
      <AddPayment {...props} />
    </VFScreen>
  );
};
AddPaymentScreen.propTypes = {
  onClose: PropTypes.func,
  onBack: PropTypes.func,
};
export default AddPaymentScreen;
